import React, { useState, useEffect, useCallback } from 'react'
import { useAuthContext } from '@/hooks/useAuthContext'
import ScriptGenerator from './setup/ScriptGenerator'
import { WidgetService } from '@/services/widget.service'
import type { WidgetConfig } from '@/types/widget'

const DashboardSetup: React.FC = () => {
  const { user } = useAuthContext()
  const [isLoading, setIsLoading] = useState(true)
  const [savedConfig, setSavedConfig] = useState<WidgetConfig | null>(null)

  const loadWidgetConfig = useCallback(async () => {
    if (!user?.id) return

    try {
      setIsLoading(true)
      const config = await WidgetService.getWidgetConfig(user.id)
      setSavedConfig(config)
    } catch (error) {
      console.error('Error loading widget config:', error)
    } finally {
      setIsLoading(false)
    }
  }, [user?.id])

  useEffect(() => {
    loadWidgetConfig()
  }, [loadWidgetConfig])

  if (isLoading) {
    return (
      <div className="dashboard-setup">
        <div className="dashboard-setup-loading">Loading...</div>
      </div>
    )
  }

  const scriptConfig = {
    websiteId: savedConfig?.id || 'temp-id',
    placement: savedConfig?.placement || 'right',
    dataSource: savedConfig?.dataSource || 'all-content',
    logoUrl: savedConfig?.logoUrl || undefined,
    companyName: savedConfig?.companyName || undefined,
    primaryColor: savedConfig?.primaryColor || '#007bff',
  }

  return (
    <div className="dashboard-setup">
      <div className="dashboard-setup-header">
        <h1 className="dashboard-setup-title">Setup</h1>
        <p className="dashboard-setup-subtitle">
          Copy the code snippet below and add it to your website
        </p>
      </div>

      <div className="dashboard-setup-content">
        <div className="dashboard-setup-section">
          <ScriptGenerator config={scriptConfig} />
        </div>
      </div>
    </div>
  )
}

export default DashboardSetup
